export const categories = [
  { id: 'warming-patches', name: '保暖贴系列', description: '自发热保暖贴，持久恒温，贴身守护', icon: 'ri-sun-line' },
  { id: 'outdoor-heating', name: '户外取暖系列', description: '专为户外环境设计的便携取暖设备', icon: 'ri-compass-3-line' },
  { id: 'daily-warm', name: '日常暖身系列', description: '居家办公日常取暖，舒适每一天', icon: 'ri-home-heart-line' },
  { id: 'winter-gear', name: '冬季装备系列', description: '冬季出行全副武装，从头暖到脚', icon: 'ri-snowy-line' },
];

export const products = [
  {
    id: 'p001',
    name: '热久久经典保暖贴',
    categoryId: 'warming-patches',
    price: 29.9,
    description: '经典款自发热保暖贴，持续发热12小时，平均温度53°C，轻薄贴身，适合日常使用。采用铁粉氧化发热技术，安全环保。',
    features: ['12小时持久发热', '平均温度53°C', '轻薄无感', '安全铁粉氧化技术'],
    imageQuery: 'Single portable warming patch product on clean light cream background%2C minimalist product photography%2C soft warm lighting%2C modern packaged heating pad design%2C professional commercial product shot%2C simple elegant composition%2C warm amber tones',
  },
  {
    id: 'p002',
    name: '热久久强效保暖贴',
    categoryId: 'warming-patches',
    price: 39.9,
    description: '升级版强效保暖贴，持续发热18小时，平均温度58°C，加大尺寸，适合极度寒冷环境。户外作业和冬季运动的理想选择。',
    features: ['18小时超长发热', '平均温度58°C', '加大尺寸覆盖', '极寒环境适用'],
    imageQuery: 'Large size intensive heating patch product on minimal warm beige backdrop%2C clean studio product photography%2C soft directional light%2C modern packaging with warm orange accents%2C professional commercial shot%2C simple composition',
  },
  {
    id: 'p003',
    name: '热久久便携暖手宝',
    categoryId: 'daily-warm',
    price: 89.9,
    description: 'USB充电便携暖手宝，三档温度调节（45°C/55°C/65°C），续航长达8小时，小巧便携，冬日通勤必备。',
    features: ['三档温度调节', '8小时续航', 'USB快速充电', '小巧便携'],
    imageQuery: 'Elegant portable rechargeable hand warmer on soft cream surface%2C minimalist product photography%2C warm ambient lighting%2C sleek modern design in warm tones%2C professional commercial shot%2C clean composition with soft shadows',
  },
  {
    id: 'p004',
    name: '热久久户外加热马甲',
    categoryId: 'outdoor-heating',
    price: 299.9,
    description: '智能温控加热马甲，内置5片发热区域，三档温度调节，续航6-8小时，防风防水面料，户外工作者必备。',
    features: ['5片发热区域', '智能温控芯片', '防风防水面料', '6-8小时续航'],
    imageQuery: 'Professional heated vest outdoor winter gear on clean warm background%2C minimalist product photography%2C soft studio lighting%2C modern technical outdoor apparel design%2C professional commercial shot%2C warm tones with technical aesthetic',
  },
  {
    id: 'p005',
    name: '热久久加热鞋垫',
    categoryId: 'winter-gear',
    price: 149.9,
    description: '智能控温加热鞋垫，无线遥控三档温度调节，续航10小时，适配各类鞋型，让双脚在寒冬中保持温暖。',
    features: ['无线遥控', '三档温度调节', '10小时续航', '适配各类鞋型'],
    imageQuery: 'Smart heated insoles product on minimal cream backdrop%2C clean studio product photography%2C soft warm lighting%2C modern technical design%2C professional commercial shot%2C simple elegant composition',
  },
  {
    id: 'p006',
    name: '热久久户外暖风机',
    categoryId: 'outdoor-heating',
    price: 399.9,
    description: '便携式户外暖风机，即开即热，2000W大功率，过热保护，IPX4防水，帐篷露营和户外工作的最佳取暖伴侣。',
    features: ['2000W大功率', '即开即热', '过热保护', 'IPX4防水等级'],
    imageQuery: 'Portable outdoor heater fan product on clean warm beige background%2C minimalist product photography%2C soft studio lighting%2C modern compact design with warm accents%2C professional commercial shot%2C clean composition',
  },
  {
    id: 'p007',
    name: '热久久碳纤维发热围巾',
    categoryId: 'winter-gear',
    price: 159.9,
    description: '碳纤维发热围巾，环绕式均匀加热，三档温度调节，亲肤面料，充电宝供电，时尚保暖两不误。',
    features: ['碳纤维发热技术', '环绕均匀加热', '亲肤柔软面料', '时尚百搭设计'],
    imageQuery: 'Elegant carbon fiber heated scarf product on minimal warm cream surface%2C clean studio product photography%2C soft ambient lighting%2C stylish modern winter accessory design%2C professional commercial shot%2C warm tones composition',
  },
  {
    id: 'p008',
    name: '热久久迷你暖腰贴',
    categoryId: 'warming-patches',
    price: 35.9,
    description: '专为腰部设计的弧形保暖贴，持续发热14小时，符合人体工学弧度，弹力贴合不脱落，缓解腰部寒冷不适。',
    features: ['人体工学弧形设计', '14小时持久发热', '弹力贴合不脱落', '腰部专用'],
    imageQuery: 'Ergonomic waist warming patch product on clean light cream background%2C minimalist product photography%2C soft warm lighting%2C modern curved heating pad design%2C professional commercial shot%2C simple composition',
  },
  {
    id: 'p009',
    name: '热久久加热手套',
    categoryId: 'winter-gear',
    price: 199.9,
    description: '五指独立加热手套，每指均配备发热丝，三档调温，防水透气面料，触屏兼容，冬季户外活动必备。',
    features: ['五指独立加热', '防水透气面料', '触屏兼容', '三档温度调节'],
    imageQuery: 'Premium heated gloves product on minimal warm beige backdrop%2C clean studio product photography%2C soft directional lighting%2C modern outdoor winter gear design%2C professional commercial shot%2C warm tones',
  },
  {
    id: 'p010',
    name: '热久久USB暖脚宝',
    categoryId: 'daily-warm',
    price: 69.9,
    description: 'USB供电暖脚宝，柔软毛绒内里，快速加热至50°C，自动恒温，安全低压供电，办公居家暖脚神器。',
    features: ['USB安全低压供电', '柔软毛绒内里', '快速加热恒温', '办公居家两用'],
    imageQuery: 'Cozy USB powered foot warmer product on clean cream surface%2C minimalist product photography%2C soft warm ambient lighting%2C comfortable plush design in warm tones%2C professional commercial shot%2C clean elegant composition',
  },
];